import React from "react";

import { useParams } from "react-router-dom";

import SchedulingSettingsForm from "./SchedulingSettingsForm";
import useGetSchedulesQuery from "../../../hooks/queries/useGetSchedulesQuery";
import CircularSpinner from "../../utils/loaderEditor/CircularSpinner";

import type { JSX } from "react";

import type { FASTChannelRoutesParams } from "../../routes/FASTChannelRoutes";

export default function SchedulingSettings(): JSX.Element {
  const { channelId } = useParams<FASTChannelRoutesParams>();

  const { data: schedules, isLoading: isLoadingSchedules } =
    useGetSchedulesQuery({ channelId });

  const scheduleList = schedules?.data ?? [];

  return (
    <div className="w-full">
      {isLoadingSchedules ? (
        <div className="m-[3.125rem] flex justify-center">
          <CircularSpinner loading />
        </div>
      ) : (
        <SchedulingSettingsForm scheduleList={scheduleList} />
      )}
    </div>
  );
}
